import React from 'react';

import type { IconProps } from '~/components/icons/types';
import colors from '~/theme/tailwind/colors';
import cn from '~/Utils/cn';

interface Props extends React.SVGProps<SVGSVGElement>, IconProps {
  disableStrokeColor?: boolean;
}
const SvgIcon: React.FC<Props> = ({
  iconColor = colors.slate['900'],
  size,
  disabled,
  children,
  disableStrokeColor = false,
  className,
  style,
  ...rest
}) => {
  const svgProps = {
    fill: iconColor,
    ...(disableStrokeColor
      ? {}
      : {
          stroke: iconColor,
        }),
    opacity: disabled ? 0.26 : 1,
    width: size || 16,
    height: size || 16,
    className: cn('text-[length:var(--icon-font-size)]', className),
    style: {
      // Some icon-related styling assumes the icon height is equivalent to its font-size (e.g. MUI
      // places a Select's dropdown icon with `calc(50% - .5em)`). Our SVG system sets icon size
      // independently of its font-size, so here we set the font-size to the icon height, so that
      // font-size based styling applied to the icon will not break.
      // (Some of our icons set a fixed width and height, which overrides the size prop — that's why
      // `rest.height` takes precedence over `size` here. It is assumed numeric, as all of them pass
      // one; an SVG length like '100%' would yield an invalid value and leave the font-size inherited.)
      '--icon-font-size': `${rest.height ?? size ?? 16}px`,
      ...style,
    },
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...svgProps} {...rest}>
      {children}
    </svg>
  );
};

export default SvgIcon;
